var cldrData = [
{
    "main": {
        "ja_JP": {
            "identity": {
                "version": {
                    "_number": "$改訂: 12418 $",
                    "_cldrVersion": "29"
                },
                "language": "ja"
            },
            "dates": {
                "calendars": {
                    "gregorian": {
                        "months": {
                            "format": {
                                "abbreviated": {
                                    "1": "1 月",
                                    "2": "2 月",
                                    "3": "3 月",
                                    "4": "4 月",
                                    "5": "5 月",
                                    "6": "6 月",
                                    "7": "7 月",
                                    "8": "8 月",
                                    "9": "9 月",
                                    "10": "10 月",
                                    "11": "11 月",
                                    "12": "12 月"
                                },
                                "narrow": {
                                    "1": "J",
                                    "2": "F",
                                    "3": "M",
                                    "4": "A",
                                    "5": "M",
                                    "6": "J",
                                    "7": "J",
                                    "8": "A",
                                    "9": "S",
                                    "10": "O",
                                    "11": "N",
                                    "12": "D"
                                },
                                "wide": {
                                    "1": "1 月",
                                    "2": "2 月",
                                    "3": "3 月",
                                    "4": "4 月",
                                    "5": "5 月",
                                    "6": "6 月",
                                    "7": "7 月",
                                    "8": "8 月",
                                    "9": "9 月",
                                    "10": "10 月",
                                    "11": "11 月",
                                    "12": "12 月"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "1": "1 月",
                                    "2": "2 月",
                                    "3": "3 月",
                                    "4": "4 月",
                                    "5": "5 月",
                                    "6": "6 月",
                                    "7": "7 月",
                                    "8": "8 月",
                                    "9": "9 月",
                                    "10": "10 月",
                                    "11": "11 月",
                                    "12": "12 月"
                                },
                                "narrow": {
                                    "1": "J",
                                    "2": "F",
                                    "3": "M",
                                    "4": "A",
                                    "5": "M",
                                    "6": "J",
                                    "7": "J",
                                    "8": "A",
                                    "9": "S",
                                    "10": "O",
                                    "11": "N",
                                    "12": "D"
                                },
                                "wide": {
                                    "1": "1 月",
                                    "2": "2 月",
                                    "3": "3 月",
                                    "4": "4 月",
                                    "5": "5 月",
                                    "6": "6 月",
                                    "7": "7 月",
                                    "8": "8 月",
                                    "9": "9 月",
                                    "10": "10 月",
                                    "11": "11 月",
                                    "12": "12 月"
                                }
                            }
                        },
                        "days": {
                            "format": {
                                "abbreviated": {
                                    "sun": "日",
                                    "mon": "月",
                                    "tue": "火",
                                    "wed": "水",
                                    "thu": "木",
                                    "fri": "金",
                                    "sat": "土"
                                },
                                "narrow": {
                                    "sun": "S",
                                    "mon": "M",
                                    "tue": "T",
                                    "wed": "W",
                                    "thu": "T",
                                    "fri": "F",
                                    "sat": "S"
                                },
                                "short": {
                                    "sun": "Su",
                                    "mon": "Mo",
                                    "tue": "Tu",
                                    "wed": "We",
                                    "thu": "Th",
                                    "fri": "Fr",
                                    "sat": "Sa"
                                },
                                "wide": {
                                    "sun": "日曜日",
                                    "mon": "月曜日",
                                    "tue": "火曜日",
                                    "wed": "水曜日",
                                    "thu": "木曜日",
                                    "fri": "金曜日",
                                    "sat": "土曜日"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "sun": "日",
                                    "mon": "月",
                                    "tue": "火",
                                    "wed": "水",
                                    "thu": "木",
                                    "fri": "金",
                                    "sat": "土"
                                },
                                "narrow": {
                                    "sun": "S",
                                    "mon": "M",
                                    "tue": "T",
                                    "wed": "W",
                                    "thu": "T",
                                    "fri": "F",
                                    "sat": "S"
                                },
                                "short": {
                                    "sun": "Su",
                                    "mon": "Mo",
                                    "tue": "Tu",
                                    "wed": "We",
                                    "thu": "Th",
                                    "fri": "Fr",
                                    "sat": "Sa"
                                },
                                "wide": {
                                    "sun": "日曜日",
                                    "mon": "月曜日",
                                    "tue": "火曜日",
                                    "wed": "水曜日",
                                    "thu": "木曜日",
                                    "fri": "金曜日",
                                    "sat": "土曜日"
                                }
                            }
                        },
                        "quarters": {
                            "format": {
                                "abbreviated": {
                                    "1": "Q1",
                                    "2": "Q2",
                                    "3": "Q3",
                                    "4": "Q4"
                                },
                                "narrow": {
                                    "1": "1",
                                    "2": "2",
                                    "3": "3",
                                    "4": "4"
                                },
                                "wide": {
                                    "1": "第 1 四半期",
                                    "2": "第 2 四半期",
                                    "3": "第 3 四半期",
                                    "4": "第 4 四半期"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "1": "Q1",
                                    "2": "Q2",
                                    "3": "Q3",
                                    "4": "Q4"
                                },
                                "narrow": {
                                    "1": "1",
                                    "2": "2",
                                    "3": "3",
                                    "4": "4"
                                },
                                "wide": {
                                    "1": "第 1 四半期",
                                    "2": "第 2 四半期",
                                    "3": "第 3 四半期",
                                    "4": "第 4 四半期"
                                }
                            }
                        },
                        "dayPeriods": {
                            "format": {
                                "abbreviated": {
                                    "midnight": "午前零時",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "正午",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                },
                                "narrow": {
                                    "midnight": "mi",
                                    "am": "a",
                                    "am-alt-variant": "am",
                                    "noon": "n",
                                    "pm": "p",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                },
                                "wide": {
                                    "midnight": "午前零時",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "正午",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "midnight": "午前零時",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "正午",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                },
                                "narrow": {
                                    "midnight": "午前零時",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "正午",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                },
                                "wide": {
                                    "midnight": "午前零時",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "正午",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "午前",
                                    "afternoon1": "午後",
                                    "evening1": "夕方",
                                    "night1": "夜間"
                                }
                            }
                        },
                        "eras": {
                            "eraNames": {
                                "0": "紀元前",
                                "0-alt-variant": "西暦紀元前",
                                "1": "西暦",
                                "1-alt-variant": "西暦紀元"
                            },
                            "eraAbbr": {
                                "0": "BC",
                                "0-alt-variant": "BCE",
                                "1": "AD",
                                "1-alt-variant": "CE"
                            },
                            "eraNarrow": {
                                "0": "B",
                                "0-alt-variant": "BCE",
                                "1": "A",
                                "1-alt-variant": "CE"
                            }
                        },
                        "dateFormats": {
                            "full": "y 年 MMMM d 日 (EEEE)",
                            "long": "y 年 MMMM d 日",
                            "medium": "y 年 MMM d 日",
                            "short": "yy/M/d"
                        },
                        "timeFormats": {
                            "full": "h:mm:ss a zzzz",
                            "long": "h:mm:ss a z",
                            "medium": "h:mm:ss a",
                            "short": "h:mm a"
                        },
                        "dateTimeFormats": {
                            "full": "{1} {0}",
                            "long": "{1} {0}",
                            "medium": "{1} {0}",
                            "short": "{1} {0}",
                            "availableFormats": {
                                "d": "d",
                                "E": "ccc",
                                "Ed": "d E",
                                "Ehm": "E h:mm a",
                                "EHm": "E HH:mm",
                                "Ehms": "E h:mm:ss a",
                                "EHms": "E HH:mm:ss",
                                "Gy": "y G",
                                "GyMMM": "MMM y G",
                                "GyMMMd": "MMM d, y G",
                                "GyMMMEd": "E, MMM d, y G",
                                "h": "h a",
                                "H": "HH",
                                "hm": "h:mm a",
                                "Hm": "HH:mm",
                                "hms": "h:mm:ss a",
                                "Hms": "HH:mm:ss",
                                "hmsv": "h:mm:ss a v",
                                "Hmsv": "HH:mm:ss v",
                                "hmv": "h:mm a v",
                                "Hmv": "HH:mm v",
                                "M": "L",
                                "Md": "M/d",
                                "MEd": "E, M/d",
                                "MMM": "LLL",
                                "MMMd": "MMM d",
                                "MMMEd": "E, MMM d",
                                "MMMMd": "MMMM d",
                                "ms": "mm:ss",
                                "y": "y",
                                "yM": "M/y",
                                "yMd": "M/d/y",
                                "yMEd": "E, M/d/y",
                                "yMMM": "MMM y",
                                "yMMMd": "y 年 MMM d 日",
                                "yMMMEd": "E, MMM d, y",
                                "yMMMM": "MMMM y",
                                "yQQQ": "QQQ y",
                                "yQQQQ": "QQQQ y"
                            },
                            "appendItems": {
                                "Day": "{0} ({2}: {1})",
                                "Day-Of-Week": "{0} {1}",
                                "Era": "{0} {1}",
                                "Hour": "{0} ({2}: {1})",
                                "Minute": "{0} ({2}: {1})",
                                "Month": "{0} ({2}: {1})",
                                "Quarter": "{0} ({2}: {1})",
                                "Second": "{0} ({2}: {1})",
                                "Timezone": "{0} {1}",
                                "Week": "{0} ({2}: {1})",
                                "Year": "{0} {1}"
                            },
                            "intervalFormats": {
                                "intervalFormatFallback": "{0} – {1}",
                                "d": {
                                    "d": "d – d"
                                },
                                "h": {
                                    "a": "h a – h a",
                                    "h": "h – h a"
                                },
                                "H": {
                                    "H": "HH – HH"
                                },
                                "hm": {
                                    "a": "h:mm a – h:mm a",
                                    "h": "h:mm – h:mm a",
                                    "m": "h:mm – h:mm a"
                                },
                                "Hm": {
                                    "H": "HH:mm – HH:mm",
                                    "m": "HH:mm – HH:mm"
                                },
                                "hmv": {
                                    "a": "h:mm a – h:mm a v",
                                    "h": "h:mm – h:mm a v",
                                    "m": "h:mm – h:mm a v"
                                },
                                "Hmv": {
                                    "H": "HH:mm – HH:mm v",
                                    "m": "HH:mm – HH:mm v"
                                },
                                "hv": {
                                    "a": "h a – h a v",
                                    "h": "h – h a v"
                                },
                                "Hv": {
                                    "H": "HH – HH v"
                                },
                                "M": {
                                    "M": "M – M"
                                },
                                "Md": {
                                    "d": "M/d – M/d",
                                    "M": "M/d – M/d"
                                },
                                "MEd": {
                                    "d": "E, M/d – E, M/d",
                                    "M": "E, M/d – E, M/d"
                                },
                                "MMM": {
                                    "M": "MMM – MMM"
                                },
                                "MMMd": {
                                    "d": "MMM d – d",
                                    "M": "MMM d – MMM d"
                                },
                                "MMMEd": {
                                    "d": "E, MMM d – E, MMM d",
                                    "M": "E, MMM d – E, MMM d"
                                },
                                "y": {
                                    "y": "y – y"
                                },
                                "yM": {
                                    "M": "y/M – y/M",
                                    "y": "y/M – y/M"
                                },
                                "yMd": {
                                    "d": "y/M/d – y/M/d",
                                    "M": "y/M/d – y/M/d",
                                    "y": "y/M/d – y/M/d"
                                },
                                "yMEd": {
                                    "d": "E, M/d/y – E, M/d/y",
                                    "M": "E, M/d/y – E, M/d/y",
                                    "y": "E, M/d/y – E, M/d/y"
                                },
                                "yMMM": {
                                    "M": "MMM – MMM y",
                                    "y": "MMM y – MMM y"
                                },
                                "yMMMd": {
                                    "d": "MMM d – d, y",
                                    "M": "MMM d – MMM d, y",
                                    "y": "MMM d, y – MMM d, y"
                                },
                                "yMMMEd": {
                                    "d": "E, MMM d – E, MMM d, y",
                                    "M": "E, MMM d – E, MMM d, y",
                                    "y": "E, MMM d, y – E, MMM d, y"
                                },
                                "yMMMM": {
                                    "M": "MMMM – MMMM y",
                                    "y": "MMMM y – MMMM y"
                                }
                            }
                        }
                    }
                }
            },
            "numbers": {
                "defaultNumberingSystem": "latn",
                "otherNumberingSystems": {
                "native": "latn",
                "traditional": "jpan",
                "finance": "jpanfin"
                },
                "minimumGroupingDigits": "1",
                "symbols-numberSystem-latn": {
                "decimal": ".",
                "group": ",",
                "list": ";",
                "percentSign": "%",
                "plusSign": "+",
                "minusSign": "-",
                "exponential": "E",
                "superscriptingExponent": "×",
                "perMille": "‰",
                "infinity": "∞",
                "nan": "NaN",
                "timeSeparator": ":"
                },
                "decimalFormats-numberSystem-latn": {
                "standard": "#,##0.###",
                "long": {
                    "decimalFormat": {
                    "1000-count-other": "0",
                    "10000-count-other": "0万",
                    "100000-count-other": "00万",
                    "1000000-count-other": "000万",
                    "10000000-count-other": "0000万",
                    "100000000-count-other": "0億",
                    "1000000000-count-other": "00億",
                    "10000000000-count-other": "000億",
                    "100000000000-count-other": "0000億",
                    "1000000000000-count-other": "0兆",
                    "10000000000000-count-other": "00兆",
                    "100000000000000-count-other": "000兆"
                    }
                },
                "short": {
                    "decimalFormat": {
                    "1000-count-other": "0",
                    "10000-count-other": "0万",
                    "100000-count-other": "00万",
                    "1000000-count-other": "000万",
                    "10000000-count-other": "0000万",
                    "100000000-count-other": "0億",
                    "1000000000-count-other": "00億",
                    "10000000000-count-other": "000億",
                    "100000000000-count-other": "0000億",
                    "1000000000000-count-other": "0兆",
                    "10000000000000-count-other": "00兆",
                    "100000000000000-count-other": "000兆"
                    }
                }
                },
                "scientificFormats-numberSystem-latn": {
                "standard": "#E0"
                },
                "percentFormats-numberSystem-latn": {
                "standard": "#,##0%"
                },
                "currencyFormats-numberSystem-latn": {
                "currencySpacing": {
                    "beforeCurrency": {
                    "currencyMatch": "[:^S:]",
                    "surroundingMatch": "[:digit:]",
                    "insertBetween": " "
                    },
                    "afterCurrency": {
                    "currencyMatch": "[:^S:]",
                    "surroundingMatch": "[:digit:]",
                    "insertBetween": " "
                    }
                },
                "standard": "¤#,##0.00",
                "accounting": "¤#,##0.00;(¤#,##0.00)",
                "short": {
                    "standard": {
                    "1000-count-other": "0",
                    "10000-count-other": "¤0万",
                    "100000-count-other": "¤00万",
                    "1000000-count-other": "¤000万",
                    "10000000-count-other": "¤0000万",
                    "100000000-count-other": "¤0億",
                    "1000000000-count-other": "¤00億",
                    "10000000000-count-other": "¤000億",
                    "100000000000-count-other": "¤0000億",
                    "1000000000000-count-other": "¤0兆",
                    "10000000000000-count-other": "¤00兆",
                    "100000000000000-count-other": "¤000兆"
                    }
                },
                "unitPattern-count-other": "{0}{1}"
                },
                "miscPatterns-numberSystem-latn": {
                "atLeast": "{0} 以上",
                "range": "{0}～{1}"
                },
                "currencies": {
                "ADP": {
                    "displayName": "アンドラ ペセタ",
                    "displayName-count-other": "アンドラ ペセタ",
                    "symbol": "ADP"
                },
                "AED": {
                    "displayName": "アラブ首長国連邦ディルハム",
                    "displayName-count-other": "UAE ディルハム",
                    "symbol": "AED"
                },
                "AFA": {
                    "displayName": "アフガニスタン アフガニー (1927–2002)",
                    "displayName-count-other": "アフガニスタン アフガニー (1927–2002)",
                    "symbol": "AFA"
                },
                "AFN": {
                    "displayName": "アフガニー",
                    "displayName-count-other": "アフガニー",
                    "symbol": "AFN"
                },
                "ALK": {
                    "displayName": "アルバニア レク (1946–1965)",
                    "displayName-count-other": "アルバニア レク (1946–1965)",
                    "symbol": "ALK"
                },
                "ALL": {
                    "displayName": "アルバニア レク",
                    "displayName-count-other": "アルバニア レク",
                    "symbol": "ALL"
                },
                "AMD": {
                    "displayName": "アルメニア ドラム",
                    "displayName-count-other": "アルメニア ドラム",
                    "symbol": "AMD"
                },
                "ANG": {
                    "displayName": "オランダ領アンティル ギルダー",
                    "displayName-count-other": "オランダ領アンティル ギルダー",
                    "symbol": "ANG"
                },
                "AOA": {
                    "displayName": "クワンザ",
                    "displayName-count-other": "クワンザ",
                    "symbol": "AOA",
                    "symbol-alt-narrow": "Kz"
                },
                "AOK": {
                    "displayName": "アンゴラ クワンザ (1977–1991)",
                    "displayName-count-other": "アンゴラ クワンザ (1977–1991)",
                    "symbol": "AOK"
                },
                "AON": {
                    "displayName": "アンゴラ 新クワンザ (1990–2000)",
                    "displayName-count-other": "アンゴラ 新クワンザ (1990–2000)",
                    "symbol": "AON"
                },
                "AOR": {
                    "displayName": "アンゴラ 旧クワンザ (1995–1999)",
                    "displayName-count-other": "アンゴラ 旧クワンザ (1995–1999)",
                    "symbol": "AOR"
                },
                "ARA": {
                    "displayName": "アルゼンチン アゥストラール",
                    "displayName-count-other": "アルゼンチン アゥストラール",
                    "symbol": "ARA"
                },
                "ARL": {
                    "displayName": "アルゼンチン・ペソ・レイ（1970–1983）",
                    "displayName-count-other": "アルゼンチン・ペソ・レイ（1970–1983）",
                    "symbol": "ARL"
                },
                "ARM": {
                    "displayName": "アルゼンチン・ペソ（1881–1970）",
                    "displayName-count-other": "アルゼンチン・ペソ（1881–1970）",
                    "symbol": "ARM"
                },
                "ARP": {
                    "displayName": "アルゼンチン ペソ (1983–1985)",
                    "displayName-count-other": "アルゼンチン ペソ (1983–1985)",
                    "symbol": "ARP"
                },
                "ARS": {
                    "displayName": "アルゼンチン ペソ",
                    "displayName-count-other": "アルゼンチン ペソ",
                    "symbol": "ARS",
                    "symbol-alt-narrow": "$"
                },
                "ATS": {
                    "displayName": "オーストリア シリング",
                    "displayName-count-other": "オーストリア シリング",
                    "symbol": "ATS"
                },
                "AUD": {
                    "displayName": "オーストラリア ドル",
                    "displayName-count-other": "オーストラリア ドル",
                    "symbol": "AU$",
                    "symbol-alt-narrow": "$"
                },
                "AWG": {
                    "displayName": "アルバ ギルダー",
                    "displayName-count-other": "アルバ ギルダー",
                    "symbol": "AWG"
                },
                "AZM": {
                    "displayName": "アゼルバイジャン マナト (1993–2006)",
                    "displayName-count-other": "アゼルバイジャン マナト (1993–2006)",
                    "symbol": "AZM"
                },
                "AZN": {
                    "displayName": "アゼルバイジャン マナト",
                    "displayName-count-other": "アゼルバイジャン マナト",
                    "symbol": "AZN"
                },
                "BAD": {
                    "displayName": "ボスニア・ヘルツェゴビナ ディナール (1992–1994)",
                    "displayName-count-other": "ボスニア・ヘルツェゴビナ ディナール (1992–1994)",
                    "symbol": "BAD"
                },
                "BAM": {
                    "displayName": "ボスニア マルク (BAM)",
                    "displayName-count-other": "ボスニア マルク (BAM)",
                    "symbol": "BAM",
                    "symbol-alt-narrow": "KM"
                },
                "BAN": {
                    "displayName": "ボスニア・ヘルツェゴビナ 新ディナール（1994–1997）",
                    "displayName-count-other": "ボスニア・ヘルツェゴビナ 新ディナール（1994–1997）",
                    "symbol": "BAN"
                },
                "BBD": {
                    "displayName": "バルバドス ドル",
                    "displayName-count-other": "バルバドス ドル",
                    "symbol": "BBD",
                    "symbol-alt-narrow": "$"
                },
                "BDT": {
                    "displayName": "バングラデシュ タカ",
                    "displayName-count-other": "バングラデシュ タカ",
                    "symbol": "BDT",
                    "symbol-alt-narrow": "৳"
                },
                "BEC": {
                    "displayName": "ベルギー フラン (BEC)",
                    "displayName-count-other": "ベルギー フラン (BEC)",
                    "symbol": "BEC"
                },
                "BEF": {
                    "displayName": "ベルギー フラン",
                    "displayName-count-other": "ベルギー フラン",
                    "symbol": "BEF"
                },
                "BEL": {
                    "displayName": "ベルギー フラン (BEL)",
                    "displayName-count-other": "ベルギー フラン (BEL)",
                    "symbol": "BEL"
                },
                "BGL": {
                    "displayName": "ブルガリア レフ",
                    "displayName-count-other": "ブルガリア レフ",
                    "symbol": "BGL"
                },
                "BGM": {
                    "displayName": "ブルガリア社会主義 レフ",
                    "displayName-count-other": "ブルガリア社会主義 レフ",
                    "symbol": "BGM"
                },
                "BGN": {
                    "displayName": "ブルガリア 新レフ",
                    "displayName-count-other": "ブルガリア 新レフ",
                    "symbol": "BGN"
                },
                "BGO": {
                    "displayName": "ブルガリア レフ（1879–1952）",
                    "displayName-count-other": "ブルガリア レフ（1879–1952）",
                    "symbol": "BGO"
                },
                "BHD": {
                    "displayName": "バーレーン ディナール",
                    "displayName-count-other": "バーレーン ディナール",
                    "symbol": "BHD"
                },
                "BIF": {
                    "displayName": "ブルンジ フラン",
                    "displayName-count-other": "ブルンジ フラン",
                    "symbol": "BIF"
                },
                "BMD": {
                    "displayName": "バミューダ ドル",
                    "displayName-count-other": "バミューダ ドル",
                    "symbol": "BMD",
                    "symbol-alt-narrow": "$"
                },
                "BND": {
                    "displayName": "ブルネイ ドル",
                    "displayName-count-other": "ブルネイ ドル",
                    "symbol": "BND",
                    "symbol-alt-narrow": "$"
                },
                "BOB": {
                    "displayName": "ボリビア ボリビアーノ",
                    "displayName-count-other": "ボリビア ボリビアーノ",
                    "symbol": "BOB",
                    "symbol-alt-narrow": "Bs"
                },
                "BOL": {
                    "displayName": "ボリビア ボリビアーノ (1863–1963)",
                    "displayName-count-other": "ボリビア ボリビアーノ (1863–1963)",
                    "symbol": "BOL"
                },
                "BOP": {
                    "displayName": "ボリビア ペソ",
                    "displayName-count-other": "ボリビア ペソ",
                    "symbol": "BOP"
                },
                "BOV": {
                    "displayName": "ボリビア (Mvdol)",
                    "displayName-count-other": "ボリビア (Mvdol)",
                    "symbol": "BOV"
                },
                "BRB": {
                    "displayName": "ブラジル 新クルゼイロ (1967–1986)",
                    "displayName-count-other": "ブラジル 新クルゼイロ (1967–1986)",
                    "symbol": "BRB"
                },
                "BRC": {
                    "displayName": "ブラジル クルザード (1986–1989)",
                    "displayName-count-other": "ブラジル クルザード (1986–1989)",
                    "symbol": "BRC"
                },
                "BRE": {
                    "displayName": "ブラジル クルゼイロ (1990–1993)",
                    "displayName-count-other": "ブラジル クルゼイロ (1990–1993)",
                    "symbol": "BRE"
                },
                "BRL": {
                    "displayName": "ブラジル レアル",
                    "displayName-count-other": "ブラジル レアル",
                    "symbol": "R$",
                    "symbol-alt-narrow": "R$"
                },
                "BRN": {
                    "displayName": "ブラジル 新クルザード (1989–1990)",
                    "displayName-count-other": "ブラジル 新クルザード (1989–1990)",
                    "symbol": "BRN"
                },
                "BRR": {
                    "displayName": "ブラジル クルゼイロ (1993–1994)",
                    "displayName-count-other": "ブラジル クルゼイロ (1993–1994)",
                    "symbol": "BRR"
                },
                "BRZ": {
                    "displayName": "ブラジル クルゼイロ（1942–1967）",
                    "displayName-count-other": "ブラジル クルゼイロ（1942–1967）",
                    "symbol": "BRZ"
                },
                "BSD": {
                    "displayName": "バハマ ドル",
                    "displayName-count-other": "バハマ ドル",
                    "symbol": "BSD",
                    "symbol-alt-narrow": "$"
                },
                "BTN": {
                    "displayName": "ブータン ニュルタム",
                    "displayName-count-other": "ブータン ニュルタム",
                    "symbol": "BTN"
                },
                "BUK": {
                    "displayName": "ビルマ チャット",
                    "displayName-count-other": "ビルマ チャット",
                    "symbol": "BUK"
                },
                "BWP": {
                    "displayName": "ボツワナ プラ",
                    "displayName-count-other": "ボツワナ プラ",
                    "symbol": "BWP",
                    "symbol-alt-narrow": "P"
                },
                "BYB": {
                    "displayName": "ベラルーシ 新ルーブル (1994–1999)",
                    "displayName-count-other": "ベラルーシ 新ルーブル (1994–1999)",
                    "symbol": "BYB"
                },
                "BYR": {
                    "displayName": "ベラルーシ ルーブル",
                    "displayName-count-other": "ベラルーシ ルーブル",
                    "symbol": "BYR",
                    "symbol-alt-narrow": "р."
                },
                "BZD": {
                    "displayName": "ベリーズ ドル",
                    "displayName-count-other": "ベリーズ ドル",
                    "symbol": "BZD",
                    "symbol-alt-narrow": "$"
                },
                "CAD": {
                    "displayName": "カナダ ドル",
                    "displayName-count-other": "カナダ ドル",
                    "symbol": "CA$",
                    "symbol-alt-narrow": "$"
                },
                "CDF": {
                    "displayName": "コンゴ フラン",
                    "displayName-count-other": "コンゴ フラン",
                    "symbol": "CDF"
                },
                "CHE": {
                    "displayName": "ユーロ (WIR)",
                    "displayName-count-other": "ユーロ (WIR)",
                    "symbol": "CHE"
                },
                "CHF": {
                    "displayName": "スイス フラン",
                    "displayName-count-other": "スイス フラン",
                    "symbol": "CHF"
                },
                "CHW": {
                    "displayName": "フラン (WIR)",
                    "displayName-count-other": "フラン (WIR)",
                    "symbol": "CHW"
                },
                "CLE": {
                    "displayName": "チリ エスクード",
                    "displayName-count-other": "チリ エスクード",
                    "symbol": "CLE"
                },
                "CLF": {
                    "displayName": "チリ ウニダ・デ・フォメント (UF)",
                    "displayName-count-other": "チリ ウニダ・デ・フォメント (UF)",
                    "symbol": "CLF"
                },
                "CLP": {
                    "displayName": "チリ ペソ",
                    "displayName-count-other": "チリ ペソ",
                    "symbol": "CLP",
                    "symbol-alt-narrow": "$"
                },
                "CNX": {
                    "displayName": "中国人民銀行ドル",
                    "displayName-count-other": "中国人民銀行ドル",
                    "symbol": "CNX"
                },
                "CNY": {
                    "displayName": "中国人民元",
                    "displayName-count-other": "中国人民元",
                    "symbol": "元",
                    "symbol-alt-narrow": "￥"
                },
                "COP": {
                    "displayName": "コロンビア ペソ",
                    "displayName-count-other": "コロンビア ペソ",
                    "symbol": "COP",
                    "symbol-alt-narrow": "$"
                },
                "COU": {
                    "displayName": "コロンビア レアル （UVR)",
                    "displayName-count-other": "コロンビア レアル （UVR)",
                    "symbol": "COU"
                },
                "CRC": {
                    "displayName": "コスタリカ コロン",
                    "displayName-count-other": "コスタリカ コロン",
                    "symbol": "CRC",
                    "symbol-alt-narrow": "₡"
                },
                "CSD": {
                    "displayName": "セルビア ディナール (2002–2006)",
                    "displayName-count-other": "セルビア ディナール (2002–2006)",
                    "symbol": "CSD"
                },
                "CSK": {
                    "displayName": "チェコスロバキア コルナ",
                    "displayName-count-other": "チェコスロバキア コルナ",
                    "symbol": "CSK"
                },
                "CUC": {
                    "displayName": "キューバ 兌換ペソ",
                    "displayName-count-other": "キューバ 兌換ペソ",
                    "symbol": "CUC",
                    "symbol-alt-narrow": "$"
                },
                "CUP": {
                    "displayName": "キューバ ペソ",
                    "displayName-count-other": "キューバ ペソ",
                    "symbol": "CUP",
                    "symbol-alt-narrow": "$"
                },
                "CVE": {
                    "displayName": "カーボベルデ エスクード",
                    "displayName-count-other": "カーボベルデ エスクード",
                    "symbol": "CVE"
                },
                "CYP": {
                    "displayName": "キプロス ポンド",
                    "displayName-count-other": "キプロス ポンド",
                    "symbol": "CYP"
                },
                "CZK": {
                    "displayName": "チェコ コルナ",
                    "displayName-count-other": "チェコ コルナ",
                    "symbol": "CZK",
                    "symbol-alt-narrow": "Kč"
                },
                "DDM": {
                    "displayName": "東ドイツ マルク",
                    "displayName-count-other": "東ドイツ マルク",
                    "symbol": "DDM"
                },
                "DEM": {
                    "displayName": "ドイツ マルク",
                    "displayName-count-other": "ドイツ マルク",
                    "symbol": "DEM"
                },
                "DJF": {
                    "displayName": "ジブチ フラン",
                    "displayName-count-other": "ジブチ フラン",
                    "symbol": "DJF"
                },
                "DKK": {
                    "displayName": "デンマーク クローネ",
                    "displayName-count-other": "デンマーク クローネ",
                    "symbol": "DKK",
                    "symbol-alt-narrow": "kr"
                },
                "DOP": {
                    "displayName": "ドミニカ ペソ",
                    "displayName-count-other": "ドミニカ ペソ",
                    "symbol": "DOP",
                    "symbol-alt-narrow": "$"
                },
                "DZD": {
                    "displayName": "アルジェリア ディナール",
                    "displayName-count-other": "アルジェリア ディナール",
                    "symbol": "DZD"
                },
                "ECS": {
                    "displayName": "エクアドル スクレ",
                    "displayName-count-other": "エクアドル スクレ",
                    "symbol": "ECS"
                },
                "ECV": {
                    "displayName": "エクアドル (UVC)",
                    "displayName-count-other": "エクアドル (UVC)",
                    "symbol": "ECV"
                },
                "EEK": {
                    "displayName": "エストニア クルーン",
                    "displayName-count-other": "エストニア クルーン",
                    "symbol": "EEK"
                },
                "EGP": {
                    "displayName": "エジプト ポンド",
                    "displayName-count-other": "エジプト ポンド",
                    "symbol": "EGP",
                    "symbol-alt-narrow": "E£"
                },
                "ERN": {
                    "displayName": "エリトリア ナクファ",
                    "displayName-count-other": "エリトリア ナクファ",
                    "symbol": "ERN"
                },
                "ESA": {
                    "displayName": "スペインペセタ（勘定A）",
                    "displayName-count-other": "スペインペセタ（勘定A）",
                    "symbol": "ESA"
                },
                "ESB": {
                    "displayName": "スペイン 兌換ペセタ",
                    "displayName-count-other": "スペイン 兌換ペセタ",
                    "symbol": "ESB"
                },
                "ESP": {
                    "displayName": "スペイン ペセタ",
                    "displayName-count-other": "スペイン ペセタ",
                    "symbol": "ESP",
                    "symbol-alt-narrow": "₧"
                },
                "ETB": {
                    "displayName": "エチオピア ブル",
                    "displayName-count-other": "エチオピア ブル",
                    "symbol": "ETB"
                },
                "EUR": {
                    "displayName": "ユーロ",
                    "displayName-count-other": "ユーロ",
                    "symbol": "€",
                    "symbol-alt-narrow": "€"
                },
                "FIM": {
                    "displayName": "フィンランド マルカ",
                    "displayName-count-other": "フィンランド マルカ",
                    "symbol": "FIM"
                },
                "FJD": {
                    "displayName": "フィジー諸島 ドル",
                    "displayName-count-other": "フィジー諸島 ドル",
                    "symbol": "FJD",
                    "symbol-alt-narrow": "$"
                },
                "FKP": {
                    "displayName": "フォークランド（マルビナス）諸島 ポンド",
                    "displayName-count-other": "フォークランド（マルビナス）諸島 ポンド",
                    "symbol": "FKP",
                    "symbol-alt-narrow": "£"
                },
                "FRF": {
                    "displayName": "フランス フラン",
                    "displayName-count-other": "フランス フラン",
                    "symbol": "FRF"
                },
                "GBP": {
                    "displayName": "英国ポンド",
                    "displayName-count-other": "英国ポンド",
                    "symbol": "£",
                    "symbol-alt-narrow": "£"
                },
                "GEK": {
                    "displayName": "ジョージア クーポン ラリ",
                    "displayName-count-other": "ジョージア クーポン ラリ",
                    "symbol": "GEK"
                },
                "GEL": {
                    "displayName": "ジョージア ラリ",
                    "displayName-count-other": "ジョージア ラリ",
                    "symbol": "GEL",
                    "symbol-alt-narrow": "₾",
                    "symbol-alt-variant": "₾"
                },
                "GHC": {
                    "displayName": "ガーナ セディ (1979–2007)",
                    "displayName-count-other": "ガーナ セディ (1979–2007)",
                    "symbol": "GHC"
                },
                "GHS": {
                    "displayName": "ガーナ セディ",
                    "displayName-count-other": "ガーナ セディ",
                    "symbol": "GHS"
                },
                "GIP": {
                    "displayName": "ジブラルタル ポンド",
                    "displayName-count-other": "ジブラルタル ポンド",
                    "symbol": "GIP",
                    "symbol-alt-narrow": "£"
                },
                "GMD": {
                    "displayName": "ガンビア ダラシ",
                    "displayName-count-other": "ガンビア ダラシ",
                    "symbol": "GMD"
                },
                "GNF": {
                    "displayName": "ギニア フラン",
                    "displayName-count-other": "ギニア フラン",
                    "symbol": "GNF",
                    "symbol-alt-narrow": "FG"
                },
                "GNS": {
                    "displayName": "ギニア シリー",
                    "displayName-count-other": "ギニア シリー",
                    "symbol": "GNS"
                },
                "GQE": {
                    "displayName": "赤道ギニア エクウェレ",
                    "displayName-count-other": "赤道ギニア エクウェレ",
                    "symbol": "GQE"
                },
                "GRD": {
                    "displayName": "ギリシャ ドラクマ",
                    "displayName-count-other": "ギリシャ ドラクマ",
                    "symbol": "GRD"
                },
                "GTQ": {
                    "displayName": "グアテマラ ケツァル",
                    "displayName-count-other": "グアテマラ ケツァル",
                    "symbol": "GTQ",
                    "symbol-alt-narrow": "Q"
                },
                "GWE": {
                    "displayName": "ポルトガル領ギニア エスクード",
                    "displayName-count-other": "ポルトガル領ギニア エスクード",
                    "symbol": "GWE"
                },
                "GWP": {
                    "displayName": "ギニアビサウ ペソ",
                    "displayName-count-other": "ギニアビサウ ペソ",
                    "symbol": "GWP"
                },
                "GYD": {
                    "displayName": "ガイアナ ドル",
                    "displayName-count-other": "ガイアナ ドル",
                    "symbol": "GYD",
                    "symbol-alt-narrow": "$"
                },
                "HKD": {
                    "displayName": "香港ドル",
                    "displayName-count-other": "香港ドル",
                    "symbol": "HK$",
                    "symbol-alt-narrow": "$"
                },
                "HNL": {
                    "displayName": "ホンジュラス レンピラ",
                    "displayName-count-other": "ホンジュラス レンピラ",
                    "symbol": "HNL",
                    "symbol-alt-narrow": "L"
                },
                "HRD": {
                    "displayName": "クロアチア ディナール",
                    "displayName-count-other": "クロアチア ディナール",
                    "symbol": "HRD"
                },
                "HRK": {
                    "displayName": "クロアチア クーナ",
                    "displayName-count-other": "クロアチア クーナ",
                    "symbol": "HRK",
                    "symbol-alt-narrow": "kn"
                },
                "HTG": {
                    "displayName": "ハイチ グールド",
                    "displayName-count-other": "ハイチ グールド",
                    "symbol": "HTG"
                },
                "HUF": {
                    "displayName": "ハンガリー フォリント",
                    "displayName-count-other": "ハンガリー フォリント",
                    "symbol": "HUF",
                    "symbol-alt-narrow": "Ft"
                },
                "IDR": {
                    "displayName": "インドネシア ルピア",
                    "displayName-count-other": "インドネシア ルピア",
                    "symbol": "IDR",
                    "symbol-alt-narrow": "Rp"
                },
                "IEP": {
                    "displayName": "アイリッシュ ポンド",
                    "displayName-count-other": "アイリッシュ ポンド",
                    "symbol": "IEP"
                },
                "ILP": {
                    "displayName": "イスラエル ポンド",
                    "displayName-count-other": "イスラエル ポンド",
                    "symbol": "ILP"
                },
                "ILR": {
                    "displayName": "イスラエル シェケル (1980–1985)",
                    "displayName-count-other": "イスラエル シェケル (1980–1985)",
                    "symbol": "ILR"
                },
                "ILS": {
                    "displayName": "イスラエル新シェケル",
                    "displayName-count-other": "イスラエル新シェケル",
                    "symbol": "₪",
                    "symbol-alt-narrow": "₪"
                },
                "INR": {
                    "displayName": "インド ルピー",
                    "displayName-count-other": "インド ルピー",
                    "symbol": "₹",
                    "symbol-alt-narrow": "₹"
                },
                "IQD": {
                    "displayName": "イラク ディナール",
                    "displayName-count-other": "イラク ディナール",
                    "symbol": "IQD"
                },
                "IRR": {
                    "displayName": "イラン リアル",
                    "displayName-count-other": "イラン リアル",
                    "symbol": "IRR"
                },
                "ISJ": {
                    "displayName": "アイスランド クローナ (1918–1981)",
                    "displayName-count-other": "アイスランド クローナ (1918–1981)",
                    "symbol": "ISJ"
                },
                "ISK": {
                    "displayName": "アイスランド クローナ",
                    "displayName-count-other": "アイスランド クローナ",
                    "symbol": "ISK",
                    "symbol-alt-narrow": "kr"
                },
                "ITL": {
                    "displayName": "イタリア リラ",
                    "displayName-count-other": "イタリア リラ",
                    "symbol": "ITL"
                },
                "JMD": {
                    "displayName": "ジャマイカ ドル",
                    "displayName-count-other": "ジャマイカ ドル",
                    "symbol": "JMD",
                    "symbol-alt-narrow": "$"
                },
                "JOD": {
                    "displayName": "ヨルダン ディナール",
                    "displayName-count-other": "ヨルダン ディナール",
                    "symbol": "JOD"
                },
                "JPY": {
                    "displayName": "日本円",
                    "displayName-count-other": "円",
                    "symbol": "￥",
                    "symbol-alt-narrow": "￥"
                },
                "KES": {
                    "displayName": "ケニア シリング",
                    "displayName-count-other": "ケニア シリング",
                    "symbol": "KES"
                },
                "KGS": {
                    "displayName": "キルギスタン ソム",
                    "displayName-count-other": "キルギスタン ソム",
                    "symbol": "KGS"
                },
                "KHR": {
                    "displayName": "カンボジア リエル",
                    "displayName-count-other": "カンボジア リエル",
                    "symbol": "KHR",
                    "symbol-alt-narrow": "៛"
                },
                "KMF": {
                    "displayName": "コモロ フラン",
                    "displayName-count-other": "コモロ フラン",
                    "symbol": "KMF",
                    "symbol-alt-narrow": "CF"
                },
                "KPW": {
                    "displayName": "北朝鮮 ウォン",
                    "displayName-count-other": "北朝鮮 ウォン",
                    "symbol": "KPW",
                    "symbol-alt-narrow": "₩"
                },
                "KRH": {
                    "displayName": "韓国 ファン（1953–1962）",
                    "displayName-count-other": "韓国 ファン（1953–1962）",
                    "symbol": "KRH"
                },
                "KRO": {
                    "displayName": "韓国 ウォン（1945–1953）",
                    "displayName-count-other": "韓国 ウォン（1945–1953）",
                    "symbol": "KRO"
                },
                "KRW": {
                    "displayName": "韓国 ウォン",
                    "displayName-count-other": "韓国 ウォン",
                    "symbol": "₩",
                    "symbol-alt-narrow": "₩"
                },
                "KWD": {
                    "displayName": "クウェート ディナール",
                    "displayName-count-other": "クウェート ディナール",
                    "symbol": "KWD"
                },
                "KYD": {
                    "displayName": "ケイマン諸島 ドル",
                    "displayName-count-other": "ケイマン諸島 ドル",
                    "symbol": "KYD",
                    "symbol-alt-narrow": "$"
                },
                "KZT": {
                    "displayName": "カザフスタン テンゲ",
                    "displayName-count-other": "カザフスタン テンゲ",
                    "symbol": "KZT",
                    "symbol-alt-narrow": "₸"
                },
                "LAK": {
                    "displayName": "ラオス キープ",
                    "displayName-count-other": "ラオス キープ",
                    "symbol": "LAK",
                    "symbol-alt-narrow": "₭"
                },
                "LBP": {
                    "displayName": "レバノン ポンド",
                    "displayName-count-other": "レバノン ポンド",
                    "symbol": "LBP",
                    "symbol-alt-narrow": "L£"
                },
                "LKR": {
                    "displayName": "スリランカ ルピー",
                    "displayName-count-other": "スリランカ ルピー",
                    "symbol": "LKR",
                    "symbol-alt-narrow": "Rs"
                },
                "LRD": {
                    "displayName": "リベリア ドル",
                    "displayName-count-other": "リベリア ドル",
                    "symbol": "LRD",
                    "symbol-alt-narrow": "$"
                },
                "LSL": {
                    "displayName": "レソト ロティ",
                    "displayName-count-other": "レソト ロティ",
                    "symbol": "LSL"
                },
                "LTL": {
                    "displayName": "リトアニア リタス",
                    "displayName-count-other": "リトアニア リタス",
                    "symbol": "LTL",
                    "symbol-alt-narrow": "Lt"
                },
                "LTT": {
                    "displayName": "リトアニア タロナ",
                    "displayName-count-other": "リトアニア タロナ",
                    "symbol": "LTT"
                },
                "LUC": {
                    "displayName": "ルクセンブルク 兌換フラン",
                    "displayName-count-other": "ルクセンブルク 兌換フラン",
                    "symbol": "LUC"
                },
                "LUF": {
                    "displayName": "ルクセンブルグ フラン",
                    "displayName-count-other": "ルクセンブルグ フラン",
                    "symbol": "LUF"
                },
                "LUL": {
                    "displayName": "ルクセンブルク 金融フラン",
                    "displayName-count-other": "ルクセンブルク 金融フラン",
                    "symbol": "LUL"
                },
                "LVL": {
                    "displayName": "ラトビア ラッツ",
                    "displayName-count-other": "ラトビア ラッツ",
                    "symbol": "LVL",
                    "symbol-alt-narrow": "Ls"
                },
                "LVR": {
                    "displayName": "ラトビア ルーブル",
                    "displayName-count-other": "ラトビア ルーブル",
                    "symbol": "LVR"
                },
                "LYD": {
                    "displayName": "リビア ディナール",
                    "displayName-count-other": "リビア ディナール",
                    "symbol": "LYD"
                },
                "MAD": {
                    "displayName": "モロッコ ディルハム",
                    "displayName-count-other": "モロッコ ディルハム",
                    "symbol": "MAD"
                },
                "MAF": {
                    "displayName": "モロッコ フラン",
                    "displayName-count-other": "モロッコ フラン",
                    "symbol": "MAF"
                },
                "MCF": {
                    "displayName": "モネガスク フラン",
                    "displayName-count-other": "モネガスク フラン",
                    "symbol": "MCF"
                },
                "MDC": {
                    "displayName": "モルドバ クーポン",
                    "displayName-count-other": "モルドバ クーポン",
                    "symbol": "MDC"
                },
                "MDL": {
                    "displayName": "モルドバ レイ",
                    "displayName-count-other": "モルドバ レイ",
                    "symbol": "MDL"
                },
                "MGA": {
                    "displayName": "マダガスカル アリアリ",
                    "displayName-count-other": "マダガスカル アリアリ",
                    "symbol": "MGA",
                    "symbol-alt-narrow": "Ar"
                },
                "MGF": {
                    "displayName": "マラガシ フラン",
                    "displayName-count-other": "マラガシ フラン",
                    "symbol": "MGF"
                },
                "MKD": {
                    "displayName": "マケドニア デナル",
                    "displayName-count-other": "マケドニア デナル",
                    "symbol": "MKD"
                },
                "MKN": {
                    "displayName": "マケドニア ディナール（1992–1993）",
                    "displayName-count-other": "マケドニア ディナール（1992–1993）",
                    "symbol": "MKN"
                },
                "MLF": {
                    "displayName": "マリ フラン",
                    "displayName-count-other": "マリ フラン",
                    "symbol": "MLF"
                },
                "MMK": {
                    "displayName": "ミャンマー チャット",
                    "displayName-count-other": "ミャンマー チャット",
                    "symbol": "MMK",
                    "symbol-alt-narrow": "K"
                },
                "MNT": {
                    "displayName": "モンゴル トグログ",
                    "displayName-count-other": "モンゴル トグログ",
                    "symbol": "MNT",
                    "symbol-alt-narrow": "₮"
                },
                "MOP": {
                    "displayName": "マカオ パタカ",
                    "displayName-count-other": "マカオ パタカ",
                    "symbol": "MOP"
                },
                "MRO": {
                    "displayName": "モーリタニア ウギア",
                    "displayName-count-other": "モーリタニア ウギア",
                    "symbol": "MRO"
                },
                "MTL": {
                    "displayName": "マルタ リラ",
                    "displayName-count-other": "マルタ リラ",
                    "symbol": "MTL"
                },
                "MTP": {
                    "displayName": "マルタ ポンド",
                    "displayName-count-other": "マルタ ポンド",
                    "symbol": "MTP"
                },
                "MUR": {
                    "displayName": "モーリシャス ルピー",
                    "displayName-count-other": "モーリシャス ルピー",
                    "symbol": "MUR",
                    "symbol-alt-narrow": "Rs"
                },
                "MVP": {
                    "displayName": "モルディブ諸島 ルピー",
                    "displayName-count-other": "モルディブ諸島 ルピー",
                    "symbol": "MVP"
                },
                "MVR": {
                    "displayName": "モルディブ諸島 ルフィア",
                    "displayName-count-other": "モルディブ諸島 ルフィア",
                    "symbol": "MVR"
                },
                "MWK": {
                    "displayName": "マラウィ クワチャ",
                    "displayName-count-other": "マラウィ クワチャ",
                    "symbol": "MWK"
                },
                "MXN": {
                    "displayName": "メキシコ ペソ",
                    "displayName-count-other": "メキシコ ペソ",
                    "symbol": "MX$",
                    "symbol-alt-narrow": "$"
                },
                "MXP": {
                    "displayName": "メキシコ ペソ (1861–1992)",
                    "displayName-count-other": "メキシコ ペソ (1861–1992)",
                    "symbol": "MXP"
                },
                "MXV": {
                    "displayName": "メキシコ (UDI)",
                    "displayName-count-other": "メキシコ (UDI)",
                    "symbol": "MXV"
                },
                "MYR": {
                    "displayName": "マレーシア リンギット",
                    "displayName-count-other": "マレーシア リンギット",
                    "symbol": "MYR",
                    "symbol-alt-narrow": "RM"
                },
                "MZE": {
                    "displayName": "モザンピーク エスクード",
                    "displayName-count-other": "モザンピーク エスクード",
                    "symbol": "MZE"
                },
                "MZM": {
                    "displayName": "モザンビーク メティカル (1980–2006)",
                    "displayName-count-other": "モザンビーク メティカル (1980–2006)",
                    "symbol": "MZM"
                },
                "MZN": {
                    "displayName": "モザンビーク メティカル",
                    "displayName-count-other": "モザンビーク メティカル",
                    "symbol": "MZN"
                },
                "NAD": {
                    "displayName": "ナミビア ドル",
                    "displayName-count-other": "ナミビア ドル",
                    "symbol": "NAD",
                    "symbol-alt-narrow": "$"
                },
                "NGN": {
                    "displayName": "ナイジェリア ナイラ",
                    "displayName-count-other": "ナイジェリア ナイラ",
                    "symbol": "NGN",
                    "symbol-alt-narrow": "₦"
                },
                "NIC": {
                    "displayName": "ニカラグア コルドバ (1988–1991)",
                    "displayName-count-other": "ニカラグア コルドバ (1988–1991)",
                    "symbol": "NIC"
                },
                "NIO": {
                    "displayName": "ニカラグア コルドバ オロ",
                    "displayName-count-other": "ニカラグア コルドバ オロ",
                    "symbol": "NIO",
                    "symbol-alt-narrow": "C$"
                },
                "NLG": {
                    "displayName": "オランダ ギルダー",
                    "displayName-count-other": "オランダ ギルダー",
                    "symbol": "NLG"
                },
                "NOK": {
                    "displayName": "ノルウェー クローネ",
                    "displayName-count-other": "ノルウェー クローネ",
                    "symbol": "NOK",
                    "symbol-alt-narrow": "kr"
                },
                "NPR": {
                    "displayName": "ネパール ルピー",
                    "displayName-count-other": "ネパール ルピー",
                    "symbol": "NPR",
                    "symbol-alt-narrow": "Rs"
                },
                "NZD": {
                    "displayName": "ニュージーランド ドル",
                    "displayName-count-other": "ニュージーランド ドル",
                    "symbol": "NZ$",
                    "symbol-alt-narrow": "$"
                },
                "OMR": {
                    "displayName": "オマーン リアル",
                    "displayName-count-other": "オマーン リアル",
                    "symbol": "OMR"
                },
                "PAB": {
                    "displayName": "パナマ バルボア",
                    "displayName-count-other": "パナマ バルボア",
                    "symbol": "PAB"
                },
                "PEI": {
                    "displayName": "ペルー インティ",
                    "displayName-count-other": "ペルー インティ",
                    "symbol": "PEI"
                },
                "PEN": {
                    "displayName": "ペルー 新ソル",
                    "displayName-count-other": "ペルー 新ソル",
                    "symbol": "PEN"
                },
                "PES": {
                    "displayName": "ペルー ソル (1863–1965)",
                    "displayName-count-other": "ペルー ソル (1863–1965)",
                    "symbol": "PES"
                },
                "PGK": {
                    "displayName": "パプアニューギニア キナ",
                    "displayName-count-other": "パプアニューギニア キナ",
                    "symbol": "PGK"
                },
                "PHP": {
                    "displayName": "フィリピン ペソ",
                    "displayName-count-other": "フィリピン ペソ",
                    "symbol": "PHP",
                    "symbol-alt-narrow": "₱"
                },
                "PKR": {
                    "displayName": "パキスタン ルピー",
                    "displayName-count-other": "パキスタン ルピー",
                    "symbol": "PKR",
                    "symbol-alt-narrow": "Rs"
                },
                "PLN": {
                    "displayName": "ポーランド ズウォティ",
                    "displayName-count-other": "ポーランド ズウォティ",
                    "symbol": "PLN",
                    "symbol-alt-narrow": "zł"
                },
                "PLZ": {
                    "displayName": "ポーランド ズウォティ (1950–1995)",
                    "displayName-count-other": "ポーランド ズウォティ (1950–1995)",
                    "symbol": "PLZ"
                },
                "PTE": {
                    "displayName": "ポルトガル エスクード",
                    "displayName-count-other": "ポルトガル エスクード",
                    "symbol": "PTE"
                },
                "PYG": {
                    "displayName": "パラグアイ グアラニ",
                    "displayName-count-other": "パラグアイ グアラニ",
                    "symbol": "PYG",
                    "symbol-alt-narrow": "₲"
                },
                "QAR": {
                    "displayName": "カタール リアル",
                    "displayName-count-other": "カタール リアル",
                    "symbol": "QAR"
                },
                "RHD": {
                    "displayName": "ローデシア ドル",
                    "displayName-count-other": "ローデシア ドル",
                    "symbol": "RHD"
                },
                "ROL": {
                    "displayName": "ルーマニア レイ (1952–2006)",
                    "displayName-count-other": "ルーマニア レイ (1952–2006)",
                    "symbol": "ROL"
                },
                "RON": {
                    "displayName": "ルーマニア レイ",
                    "displayName-count-other": "ルーマニア レイ",
                    "symbol": "RON"
                },
                "RSD": {
                    "displayName": "ディナール (セルビア)",
                    "displayName-count-other": "ディナール (セルビア)",
                    "symbol": "RSD"
                },
                "RUB": {
                    "displayName": "ロシア ルーブル",
                    "displayName-count-other": "ロシア ルーブル",
                    "symbol": "RUB",
                    "symbol-alt-narrow": "₽"
                },
                "RUR": {
                    "displayName": "ロシア ルーブル (1991–1998)",
                    "displayName-count-other": "ロシア ルーブル (1991–1998)",
                    "symbol": "RUR",
                    "symbol-alt-narrow": "р."
                },
                "RWF": {
                    "displayName": "ルワンダ フラン",
                    "displayName-count-other": "ルワンダ フラン",
                    "symbol": "RWF",
                    "symbol-alt-narrow": "RF"
                },
                "SAR": {
                    "displayName": "サウジ リヤル",
                    "displayName-count-other": "サウジ リヤル",
                    "symbol": "SAR"
                },
                "SBD": {
                    "displayName": "ソロモン諸島 ドル",
                    "displayName-count-other": "ソロモン諸島 ドル",
                    "symbol": "SBD",
                    "symbol-alt-narrow": "$"
                },
                "SCR": {
                    "displayName": "セーシェル ルピー",
                    "displayName-count-other": "セーシェル ルピー",
                    "symbol": "SCR"
                },
                "SDD": {
                    "displayName": "スーダン ディナール (1992–2007)",
                    "displayName-count-other": "スーダン ディナール (1992–2007)",
                    "symbol": "SDD"
                },
                "SDG": {
                    "displayName": "スーダン ポンド",
                    "displayName-count-other": "スーダン ポンド",
                    "symbol": "SDG"
                },
                "SDP": {
                    "displayName": "スーダン ポンド (1957–1998)",
                    "displayName-count-other": "スーダン ポンド (1957–1998)",
                    "symbol": "SDP"
                },
                "SEK": {
                    "displayName": "スウェーデン クローナ",
                    "displayName-count-other": "スウェーデン クローナ",
                    "symbol": "SEK",
                    "symbol-alt-narrow": "kr"
                },
                "SGD": {
                    "displayName": "シンガポール ドル",
                    "displayName-count-other": "シンガポール ドル",
                    "symbol": "SGD",
                    "symbol-alt-narrow": "$"
                },
                "SHP": {
                    "displayName": "セントヘレナ島 ポンド",
                    "displayName-count-other": "セントヘレナ島 ポンド",
                    "symbol": "SHP",
                    "symbol-alt-narrow": "£"
                },
                "SIT": {
                    "displayName": "スロベニア トラール",
                    "displayName-count-other": "スロベニア トラール",
                    "symbol": "SIT"
                },
                "SKK": {
                    "displayName": "スロバキア コルナ",
                    "displayName-count-other": "スロバキア コルナ",
                    "symbol": "SKK"
                },
                "SLL": {
                    "displayName": "シエラレオネ レオン",
                    "displayName-count-other": "シエラレオネ レオン",
                    "symbol": "SLL"
                },
                "SOS": {
                    "displayName": "ソマリア シリング",
                    "displayName-count-other": "ソマリア シリング",
                    "symbol": "SOS"
                },
                "SRD": {
                    "displayName": "スリナム ドル",
                    "displayName-count-other": "スリナム ドル",
                    "symbol": "SRD",
                    "symbol-alt-narrow": "$"
                },
                "SRG": {
                    "displayName": "スリナム ギルダー",
                    "displayName-count-other": "スリナム ギルダー",
                    "symbol": "SRG"
                },
                "SSP": {
                    "displayName": "南スーダン・ポンド",
                    "displayName-count-other": "南スーダン・ポンド",
                    "symbol": "SSP",
                    "symbol-alt-narrow": "£"
                },
                "STD": {
                    "displayName": "サントメ・プリンシペ ドブラ",
                    "displayName-count-other": "サントメ・プリンシペ ドブラ",
                    "symbol": "STD",
                    "symbol-alt-narrow": "Db"
                },
                "SUR": {
                    "displayName": "ソ連 ルーブル",
                    "displayName-count-other": "ソ連 ルーブル",
                    "symbol": "SUR"
                },
                "SVC": {
                    "displayName": "エルサルバドル コロン",
                    "displayName-count-other": "エルサルバドル コロン",
                    "symbol": "SVC"
                },
                "SYP": {
                    "displayName": "シリア ポンド",
                    "displayName-count-other": "シリア ポンド",
                    "symbol": "SYP",
                    "symbol-alt-narrow": "£"
                },
                "SZL": {
                    "displayName": "スワジランド リランゲニ",
                    "displayName-count-other": "スワジランド リランゲニ",
                    "symbol": "SZL"
                },
                "THB": {
                    "displayName": "タイ バーツ",
                    "displayName-count-other": "タイ バーツ",
                    "symbol": "฿",
                    "symbol-alt-narrow": "฿"
                },
                "TJR": {
                    "displayName": "タジキスタン ルーブル",
                    "displayName-count-other": "タジキスタン ルーブル",
                    "symbol": "TJR"
                },
                "TJS": {
                    "displayName": "タジキスタン ソモニ",
                    "displayName-count-other": "タジキスタン ソモニ",
                    "symbol": "TJS"
                },
                "TMM": {
                    "displayName": "トルクメニスタン マナト (1993–2009)",
                    "displayName-count-other": "トルクメニスタン マナト (1993–2009)",
                    "symbol": "TMM"
                },
                "TMT": {
                    "displayName": "トルクメニスタン マナト",
                    "displayName-count-other": "トルクメニスタン マナト",
                    "symbol": "TMT"
                },
                "TND": {
                    "displayName": "チュニジア ディナール",
                    "displayName-count-other": "チュニジア ディナール",
                    "symbol": "TND"
                },
                "TOP": {
                    "displayName": "トンガ パ・アンガ",
                    "displayName-count-other": "トンガ パ・アンガ",
                    "symbol": "TOP",
                    "symbol-alt-narrow": "T$"
                },
                "TPE": {
                    "displayName": "ティモール エスクード",
                    "displayName-count-other": "ティモール エスクード",
                    "symbol": "TPE"
                },
                "TRL": {
                    "displayName": "トルコ リラ (1922–2005)",
                    "displayName-count-other": "トルコ リラ (1922–2005)",
                    "symbol": "TRL"
                },
                "TRY": {
                    "displayName": "新トルコリラ",
                    "displayName-count-other": "新トルコリラ",
                    "symbol": "TRY",
                    "symbol-alt-narrow": "₺",
                    "symbol-alt-variant": "TL"
                },
                "TTD": {
                    "displayName": "トリニダードトバゴ ドル",
                    "displayName-count-other": "トリニダードトバゴ ドル",
                    "symbol": "TTD",
                    "symbol-alt-narrow": "$"
                },
                "TWD": {
                    "displayName": "新台湾ドル",
                    "displayName-count-other": "新台湾ドル",
                    "symbol": "NT$",
                    "symbol-alt-narrow": "NT$"
                },
                "TZS": {
                    "displayName": "タンザニア シリング",
                    "displayName-count-other": "タンザニア シリング",
                    "symbol": "TZS"
                },
                "UAH": {
                    "displayName": "ウクライナ グリブナ",
                    "displayName-count-other": "ウクライナ グリブナ",
                    "symbol": "UAH",
                    "symbol-alt-narrow": "₴"
                },
                "UAK": {
                    "displayName": "ウクライナ カルボバネツ",
                    "displayName-count-other": "ウクライナ カルボバネツ",
                    "symbol": "UAK"
                },
                "UGS": {
                    "displayName": "ウガンダ シリング (1966–1987)",
                    "displayName-count-other": "ウガンダ シリング (1966–1987)",
                    "symbol": "UGS"
                },
                "UGX": {
                    "displayName": "ウガンダ シリング",
                    "displayName-count-other": "ウガンダ シリング",
                    "symbol": "UGX"
                },
                "USD": {
                    "displayName": "米ドル",
                    "displayName-count-other": "米ドル",
                    "symbol": "$",
                    "symbol-alt-narrow": "$"
                },
                "USN": {
                    "displayName": "米ドル (翌日)",
                    "displayName-count-other": "米ドル (翌日)",
                    "symbol": "USN"
                },
                "USS": {
                    "displayName": "米ドル (当日)",
                    "displayName-count-other": "米ドル (当日)",
                    "symbol": "USS"
                },
                "UYI": {
                    "displayName": "ウルグアイ ペソエン",
                    "displayName-count-other": "ウルグアイ ペソエン",
                    "symbol": "UYI"
                },
                "UYP": {
                    "displayName": "ウルグアイ ペソ (1975–1993)",
                    "displayName-count-other": "ウルグアイ ペソ (1975–1993)",
                    "symbol": "UYP"
                },
                "UYU": {
                    "displayName": "ウルグアイ ペソ",
                    "displayName-count-other": "ウルグアイ ペソ",
                    "symbol": "UYU",
                    "symbol-alt-narrow": "$"
                },
                "UZS": {
                    "displayName": "ウズベキスタン スム",
                    "displayName-count-other": "ウズベキスタン スム",
                    "symbol": "UZS"
                },
                "VEB": {
                    "displayName": "ベネズエラ ボリバル (1871–2008)",
                    "displayName-count-other": "ベネズエラ ボリバル (1871–2008)",
                    "symbol": "VEB"
                },
                "VEF": {
                    "displayName": "ベネズエラ ボリバル",
                    "displayName-count-other": "ベネズエラ ボリバル",
                    "symbol": "VEF",
                    "symbol-alt-narrow": "Bs"
                },
                "VND": {
                    "displayName": "ベトナム ドン",
                    "displayName-count-other": "ベトナム ドン",
                    "symbol": "₫",
                    "symbol-alt-narrow": "₫"
                },
                "VNN": {
                    "displayName": "ベトナム ドン（1978–1985）",
                    "displayName-count-other": "ベトナム ドン（1978–1985）",
                    "symbol": "VNN"
                },
                "VUV": {
                    "displayName": "バヌアツ バツ",
                    "displayName-count-other": "バヌアツ バツ",
                    "symbol": "VUV"
                },
                "WST": {
                    "displayName": "サモア タラ",
                    "displayName-count-other": "サモア タラ",
                    "symbol": "WST"
                },
                "XAF": {
                    "displayName": "中央アフリカ CFA フラン",
                    "displayName-count-other": "中央アフリカ CFA フラン",
                    "symbol": "FCFA"
                },
                "XAG": {
                    "displayName": "銀",
                    "displayName-count-other": "銀",
                    "symbol": "XAG"
                },
                "XAU": {
                    "displayName": "金",
                    "displayName-count-other": "金",
                    "symbol": "XAU"
                },
                "XBA": {
                    "displayName": "ヨーロッパ混合単位 (EURCO)",
                    "displayName-count-other": "ヨーロッパ混合単位 (EURCO)",
                    "symbol": "XBA"
                },
                "XBB": {
                    "displayName": "ヨーロッパ通貨単位 (EMU–6)",
                    "displayName-count-other": "ヨーロッパ通貨単位 (EMU–6)",
                    "symbol": "XBB"
                },
                "XBC": {
                    "displayName": "ヨーロッパ勘定単位 (EUA–9)",
                    "displayName-count-other": "ヨーロッパ勘定単位 (EUA–9)",
                    "symbol": "XBC"
                },
                "XBD": {
                    "displayName": "ヨーロッパ勘定単位 (EUA–17)",
                    "displayName-count-other": "ヨーロッパ勘定単位 (EUA–17)",
                    "symbol": "XBD"
                },
                "XCD": {
                    "displayName": "東カリブ ドル",
                    "displayName-count-other": "東カリブ ドル",
                    "symbol": "EC$",
                    "symbol-alt-narrow": "$"
                },
                "XDR": {
                    "displayName": "特別引き出し権",
                    "displayName-count-other": "特別引き出し権",
                    "symbol": "XDR"
                },
                "XEU": {
                    "displayName": "ヨーロッパ通貨単位",
                    "displayName-count-other": "ヨーロッパ通貨単位",
                    "symbol": "XEU"
                },
                "XFO": {
                    "displayName": "フランス金フラン",
                    "displayName-count-other": "フランス金フラン",
                    "symbol": "XFO"
                },
                "XFU": {
                    "displayName": "フランス フラン (UIC)",
                    "displayName-count-other": "フランス フラン (UIC)",
                    "symbol": "XFU"
                },
                "XOF": {
                    "displayName": "西アフリカ CFA フラン",
                    "displayName-count-other": "西アフリカ CFA フラン",
                    "symbol": "CFA"
                },
                "XPD": {
                    "displayName": "パラジウム",
                    "displayName-count-other": "パラジウム",
                    "symbol": "XPD"
                },
                "XPF": {
                    "displayName": "CFP フラン",
                    "displayName-count-other": "CFP フラン",
                    "symbol": "CFPF"
                },
                "XPT": {
                    "displayName": "プラチナ",
                    "displayName-count-other": "プラチナ",
                    "symbol": "XPT"
                },
                "XRE": {
                    "displayName": "RINET基金",
                    "displayName-count-other": "RINET基金",
                    "symbol": "XRE"
                },
                "XSU": {
                    "displayName": "スクレ",
                    "displayName-count-other": "スクレ",
                    "symbol": "XSU"
                },
                "XTS": {
                    "displayName": "テスト用通貨コード",
                    "displayName-count-other": "テスト用通貨コード",
                    "symbol": "XTS"
                },
                "XUA": {
                    "displayName": "UA (アフリカ開発銀行)",
                    "displayName-count-other": "UA (アフリカ開発銀行)",
                    "symbol": "XUA"
                },
                "XXX": {
                    "displayName": "不明または無効な通貨",
                    "displayName-count-other": "不明または無効な通貨",
                    "symbol": "XXX"
                },
                "YDD": {
                    "displayName": "イエメン ディナール",
                    "displayName-count-other": "イエメン ディナール",
                    "symbol": "YDD"
                },
                "YER": {
                    "displayName": "イエメン リアル",
                    "displayName-count-other": "イエメン リアル",
                    "symbol": "YER"
                },
                "YUD": {
                    "displayName": "ユーゴスラビア ハード・ディナール (1966–1990)",
                    "displayName-count-other": "ユーゴスラビア ハード・ディナール (1966–1990)",
                    "symbol": "YUD"
                },
                "YUM": {
                    "displayName": "ユーゴスラビア ノビ・ディナール (1994–2002)",
                    "displayName-count-other": "ユーゴスラビア ノビ・ディナール (1994–2002)",
                    "symbol": "YUM"
                },
                "YUN": {
                    "displayName": "ユーゴスラビア 兌換ディナール (1990–1992)",
                    "displayName-count-other": "ユーゴスラビア 兌換ディナール (1990–1992)",
                    "symbol": "YUN"
                },
                "YUR": {
                    "displayName": "ユーゴスラビア 改革ディナール（1992–1993）",
                    "displayName-count-other": "ユーゴスラビア 改革ディナール（1992–1993）",
                    "symbol": "YUR"
                },
                "ZAL": {
                    "displayName": "南アフリカ ランド (ZAL)",
                    "displayName-count-other": "南アフリカ ランド (ZAL)",
                    "symbol": "ZAL"
                },
                "ZAR": {
                    "displayName": "南アフリカ ランド",
                    "displayName-count-other": "南アフリカ ランド",
                    "symbol": "ZAR",
                    "symbol-alt-narrow": "R"
                },
                "ZMK": {
                    "displayName": "ザンビア クワチャ (1968–2012)",
                    "displayName-count-other": "ザンビア クワチャ (1968–2012)",
                    "symbol": "ZMK"
                },
                "ZMW": {
                    "displayName": "ザンビア クワチャ",
                    "displayName-count-other": "ザンビア クワチャ",
                    "symbol": "ZMW",
                    "symbol-alt-narrow": "ZK"
                },
                "ZRN": {
                    "displayName": "ザイール 新ザイール (1993–1998)",
                    "displayName-count-other": "ザイール 新ザイール (1993–1998)",
                    "symbol": "ZRN"
                },
                "ZRZ": {
                    "displayName": "ザイール ザイール (1971–1993)",
                    "displayName-count-other": "ザイール ザイール (1971–1993)",
                    "symbol": "ZRZ"
                },
                "ZWD": {
                    "displayName": "ジンバブエ ドル (1980–2008)",
                    "displayName-count-other": "ジンバブエ ドル (1980–2008)",
                    "symbol": "ZWD"
                },
                "ZWL": {
                    "displayName": "ジンバブエ ドル (2009)",
                    "displayName-count-other": "ジンバブエ ドル (2009)",
                    "symbol": "ZWL"
                },
                "ZWR": {
                    "displayName": "シンバブエ ドル（2008）",
                    "displayName-count-other": "シンバブエ ドル（2008）",
                    "symbol": "ZWR"
                }
                }
            }
        }
    }
},
{
    "supplemental": {
        "version": {
            "_number": "$改訂: 12447 $",
            "_unicodeVersion": "8.0.0",
            "_cldrVersion": "29"
        },
        "likelySubtags": {
            "ja": "ja-Jpan-JP"
        },
        "plurals-type-cardinal": {
            "ja": {
                "pluralRule-count-other": " @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
            }
        },
        "currencyData": {
            "fractions": {
                "ADP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "AFN": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ALL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "AMD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "BHD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "BIF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "BYR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CAD": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "5"
                },
                "CHF": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "5"
                },
                "CLF": {
                    "_rounding": "0",
                    "_digits": "4"
                },
                "CLP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "COP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CRC": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CZK": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "DEFAULT": {
                    "_rounding": "0",
                    "_digits": "2"
                },
                "DJF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ESP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "GNF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "GYD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "HUF": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "IDR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "IQD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "IRR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ISK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ITL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "JOD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "JPY": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KMF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KPW": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KRW": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KWD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "LAK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LBP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LUF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LYD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "MGA": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MGF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MMK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MNT": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MRO": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MUR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "OMR": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "PKR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "PYG": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "RSD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "RWF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SLL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SOS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "STD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SYP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TMM": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TND": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "TRL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TWD": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "TZS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UGX": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UYI": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UZS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "VND": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "VUV": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XAF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XOF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XPF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "YER": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ZMK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ZWD": {
                    "_rounding": "0",
                    "_digits": "0"
                }
            }
        }
    }
}
];